import styled from 'styled-components'
import { theme } from '../theme';

export const SoftElement = styled.div`
    border-radius: ${theme.mainBordeRadius};
    box-shadow: ${theme.softShadow};
`